import React, { Fragment } from "react";
import HealthcalculatorBtn from "../HealthcalculatorBtn";
import BootstrapTable from 'react-bootstrap-table-next';
import Loader from "../../Loader";
import classnames from 'classnames';
import { ResponsiveContainer, LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Line } from 'recharts'
import CommonLineChart from './../CommonLineChart'
import { 
  Row, 
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";


const chartData = [
  {
    name: 1,
    min: 4000, 
    max: 2400, 
    you: 2400,
  },

  {
    name: 2, 
    min: 3000, 
    max: 1398, 
    you: 2210,
  },

  {
    name: 3, 
    min: 2000, 
    max: 9800, 
    you: 2290,
  },

  {
    name: 4, 
    min: 2780, 
    max: 3908, 
    you: 2000,
  },

  {
    name: 5, 
    min: 1890, 
    max: 4800, 
    you: 2181,
  },

  {
    name: 6, 
    min: 2390, 
    max: 3800, 
    you: 2500,
  },

  {
    name: 7, 
    min: 3490, 
    max: 4300, 
    you: 9000,
  },

  {
    name: 8,
    min: 4000, 
    max: 2400, 
    you: 2400,
  },

  {
    name: 9, 
    min: 3000, 
    max: 1398, 
    you: 2210,
  },

  {
    name: 10, 
    min: 2000, 
    max: 9800, 
    you: 2290,
  },

  {
    name: 11, 
    min: 2780, 
    max: 3908, 
    you: 2000,
  },

  {
    name: 12, 
    min: 1890, 
    max: 4800, 
    you: 2181,
  },

  {
    name: 13, 
    min: 2390, 
    max: 3800, 
    you: 2500,
  },

  {
    name: 14, 
    min: 3490, 
    max: 4300, 
    you: 9000,
  },

  {
    name: 15,
    min: 4000, 
    max: 2400, 
    you: 2400,
  },

  {
    name: 16, 
    min: 3000, 
    max: 1398, 
    you: 2210,
  },

  {
    name: 17, 
    min: 2000, 
    max: 9800, 
    you: 2290,
  },

  {
    name: 18, 
    min: 2780, 
    max: 3908, 
    you: 2000,
  },

  {
    name: 19, 
    min: 1890, 
    max: 4800, 
    you: 2181,
  },

  {
    name: 20, 
    min: 2390, 
    max: 3800, 
    you: 2500,
  },

  {
    name: 21, 
    min: 3490, 
    max: 4300, 
    you: 9000,
  },

  
];

const columns=[
  {
    dataField:"serial",
    text:"S.No",
  },

  {
    dataField:"date",
    text:"Date",
  },

  {
    dataField:"age",
    text:"Age",
  },

  {
    dataField:"height_percn",
    text:"Height Percentile",
  },

  {
    dataField:"weight_percn",
    text:"Weight Percentile",
  },

  {
    dataField:"head_percn",
    text:"Head Circumference Percentile",
  },

  {
    dataField:"ratio",
    text:"Weight & Height ratio",
  },

]

const rows=[
  {
    serial:'1',
    date:'1/2/2020',
    age:'6 months',
    height_percn:'54',
    weight_percn:'66',
    head_percn:'45',
    ratio:'Normal'
  },

  {
    serial:'1',
    date:'1/2/2020',
    age:'6 months',
    height_percn:'54',
    weight_percn:'66',
    head_percn:'45',
    ratio:'Normal'
  },

  {
    serial:'1',
    date:'1/2/2020',
    age:'6 months',
    height_percn:'54',
    weight_percn:'66',
    head_percn:'45',
    ratio:'Normal'
  },

  {
    serial:'1',
    date:'1/2/2020',
    age:'6 months',
    height_percn:'54',
    weight_percn:'66',
    head_percn:'45',
    ratio:'Normal'
  },

  {
    serial:'1',
    date:'1/2/2020',
    age:'6 months',
    height_percn:'54',
    weight_percn:'66',
    head_percn:'45',
    ratio:'Normal'
  },

  {
    serial:'1',
    date:'1/2/2020',
    age:'6 months',
    height_percn:'54',
    weight_percn:'66',
    head_percn:'45',
    ratio:'Normal'
  },

  {
    serial:'1',
    date:'1/2/2020',
    age:'6 months',
    height_percn:'54',
    weight_percn:'66',
    head_percn:'45',
    ratio:'Normal'
  },

  {
    serial:'1',
    date:'1/2/2020',
    age:'6 months',
    height_percn:'54',
    weight_percn:'66',
    head_percn:'45',
    ratio:'Normal'
  },

  {
    serial:'1',
    date:'1/2/2020',
    age:'6 months',
    height_percn:'54',
    weight_percn:'66',
    head_percn:'45',
    ratio:'Normal'
  },

  {
    serial:'1',
    date:'1/2/2020',
    age:'6 months',
    height_percn:'54',
    weight_percn:'66',
    head_percn:'45',
    ratio:'Normal'
  },

  {
    serial:'1',
    date:'1/2/2020',
    age:'6 months',
    height_percn:'54',
    weight_percn:'66',
    head_percn:'45',
    ratio:'Normal'
  },

  {
    serial:'1',
    date:'1/2/2020',
    age:'6 months',
    height_percn:'54',
    weight_percn:'66',
    head_percn:'45',
    ratio:'Normal'
  },

  {
    serial:'1',
    date:'1/2/2020',
    age:'6 months',
    height_percn:'54',
    weight_percn:'66',
    head_percn:'45',
    ratio:'Normal'
  },


]

class GrowthTracker extends React.Component {

  state = {
    activeTab:'1'
  };

    componentDidMount(){};
    
    // generatePdf = () => {
    //   const { documents } = this.state
    //   let headers = ["S.No", "Date", "Start time", "End time", "Total kicks"];
    //   let bodyData = [];

    //   documents.forEach((document, index) => {
    //     bodyData.push([index + 1, document._id, document.start, document.end, document.totalKicks]);
    //   });
    //   import("../../../utils/downloadPdf")
    //   .then(({downloadPdfTable}) => {
    //     downloadPdfTable(headers, bodyData)
    //   })
    // }

    toggle = (tab) => {
      if(this.state.activeTab !== tab) this.setState({activeTab:tab})
    }

    render(){
        return (
          <Fragment>

            <Row>
              <Col md="6">
              
              </Col>

              <Col md="6">
                
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: this.state.activeTab === '1' })}
                      onClick={() => { this.toggle('1'); }}
                    >
                      Tab1
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      className={classnames({ active: this.state.activeTab === '2' })}
                      onClick={() => { this.toggle('2'); }}
                    >
                      Tab2
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      className={classnames({ active: this.state.activeTab === '3' })}
                      onClick={() => { this.toggle('3'); }}
                    >
                      Tab3
                    </NavLink>
                  </NavItem>

                </Nav>

                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId="1">
                    <Row>
                      <Col sm="12">
                        <CommonLineChart 
                          chartData={chartData}
                          xAxisLabel={{value:"month's", position:'bottom', offset:0}}
                          yAxisLabel={{value:"height (cm)", angle:"-90", position:"insideLeft"}}
                        />
                      </Col>
                    </Row>
                  </TabPane>

                  <TabPane tabId="2">
                    <Row>
                      <Col sm="12">
                        <CommonLineChart 
                          chartData={chartData}
                          xAxisLabel={{value:"month's", position:'bottom', offset:0}}
                          yAxisLabel={{value:"height (cm)", angle:"-90", position:"insideLeft"}}
                        />
                      </Col>
                    </Row>
                  </TabPane>

                  <TabPane tabId="3">
                    <Row>
                      <Col sm="12">
                        <CommonLineChart 
                          chartData={chartData}
                          xAxisLabel={{value:"month's", position:'bottom', offset:0}}
                          yAxisLabel={{value:"height (cm)", angle:"-90", position:"insideLeft"}}
                        />
                      </Col>
                    </Row>
                  </TabPane>

                </TabContent>

              </Col>
            </Row>
          
            <Row className="mt-5">
              <Col md="12">
                <BootstrapTable 
                  keyField="_id"
                  data={rows}
                  columns={columns}
                  headerClasses="tableHeader"
                  bordered={true}
                  striped={true}
                  wrapperClasses="table-responsive"
                />
              </Col>
            </Row>

            <Row>
              <Col md="12">
                <HealthcalculatorBtn link="" isPdf=""/>
              </Col>
            </Row>

          </Fragment>
        );
    }
}


export default GrowthTracker;







// WEBPACK FOOTER //
// ./src/views/HealthTools/GrowthTracker/GrowthTracker.js